import { ChevronsUpDown, LogOut } from 'lucide-react';
import { cn } from '../lib/cn';
import { Button } from './button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './dropdown-menu';

export interface UserMenuProps {
  /** Display name, or the email, or the user id — whichever the api gave us. */
  name: string;
  /** The email, when it is not already the name. */
  secondary?: string | null;
  onSignOut: () => void;
  signingOut?: boolean;
  className?: string;
}

/**
 * Identity and sign-out, at the foot of the sidebar.
 *
 * Previously a bare `<div>` of text with a full-width "Sign out" button under
 * it, which gave the least-used control on the page the most weight.
 */
export function UserMenu({ name, secondary, onSignOut, signingOut, className }: UserMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className={cn('h-auto w-full justify-between gap-2 px-2 py-2 text-left', className)}
        >
          <span className="min-w-0 flex-1">
            <span className="block truncate text-sm font-medium">{name}</span>
            {secondary && secondary !== name && (
              <span className="block truncate text-xs font-normal text-muted-foreground">
                {secondary}
              </span>
            )}
          </span>
          <ChevronsUpDown className="shrink-0 text-muted-foreground" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56">
        <DropdownMenuLabel className="break-all">{secondary ?? name}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={onSignOut} disabled={signingOut}>
          <LogOut />
          {signingOut ? 'Signing out…' : 'Sign out'}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
